import { render, staticRenderFns } from "./CartWidget.vue?vue&type=template&id=cbff0454&scoped=true"
import script from "./CartWidget.vue?vue&type=script&lang=js"
export * from "./CartWidget.vue?vue&type=script&lang=js"
import style0 from "./CartWidget.vue?vue&type=style&index=0&id=cbff0454&prod&scoped=true&lang=css"
import style1 from "./CartWidget.vue?vue&type=style&index=1&id=cbff0454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbff0454",
  null
  
)

export default component.exports